import { modularBlocksConfigKey } from '@pkg/modular-blocks/frontend/injectionKeys';
import { modularBlocksConfig } from '../config/modularBlocks';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.provide(modularBlocksConfigKey, modularBlocksConfig);
});
